// extracted by mini-css-extract-plugin
export default {"container":"deleteable-image2_container__dwPSk","container__image":"deleteable-image2_container__image__ASp0Y","container__button":"deleteable-image2_container__button__hGRNX"};